import { Directive, Input, HostListener } from "@angular/core";
@Directive({
  selector: '[appMobMask]'
})
export class MobMaskDirective {
@Input('appMobMask') control:string;
@HostListener('input', ['$event'])
onKeyDown(event: KeyboardEvent) {


  const input = event.target as HTMLInputElement;
  let trimmed = input.value.replace(/\D/g, '');
  //let trimmed = input.value.replace(/\s+/g, '');

  trimmed = trimmed.replace(/-|\//g, '');

  let numbers = [];

  if (this.control == 'zip') {
    numbers.push(trimmed.substring(0, 5));
    if (trimmed.length > 5) numbers.push(trimmed.substring(5, trimmed.length));
  }
  else if (this.control == 'date') {
    // if (trimmed.length > 10) {
    //   trimmed = trimmed.substr(0, 10);
    // }

    numbers.push(trimmed.substring(0, 2));
    if (trimmed.substring(2, 3) !== '') numbers.push(trimmed.substring(2, 4));
    if (trimmed.substring(4, 5) !== '') numbers.push(trimmed.substring(4, 8));

  }
  else {
    numbers.push(trimmed.substring(0, 3));
    if (trimmed.substring(3, 5) !== "") numbers.push(trimmed.substring(3, 6));
    if (trimmed.substring(6, 9) !== "") numbers.push(trimmed.substring(6, 10));

  }
  input.value = numbers.join(this.control == 'date' ? '/' : '-');

  // if (input.value.length == 10) {
  //   var arrText = input.value.split("/");
  //   if (parseInt(arrText[0]) > 12 || parseInt(arrText[1]) > 31) {
  //     input.value = 'Invalid Date Format'
  //   }
  //   else {
  //     input.value = numbers.join(this.control == 'date' ? '/' : '-');
  //   }
  // }
  // if (input.value.length < 10) {
  //   input.value = 'Invalid Date Format'
  // }
}

}